import { ErrorBoundary } from "app/ErrorBoundary/ErrorBoundaryDashboard";
import { GlobalFormSchema } from "features/CenterContent/RoleContent/GlobalEvents/types/formSchema";
import { FC } from "react";
import { UseFormReturn } from "react-hook-form";
import { TextAreaWithCharacterCount } from "shared/components/forms/TextAreaWithCharacterCount";
import { Flex, Stack, Text, TextLink } from "shared/components/Spor";

type DialogContentProps = {
  formMethods: UseFormReturn<GlobalFormSchema>;
  disabled?: boolean;
};

export const GlobalEventModalContent: FC<DialogContentProps> = ({
  formMethods,
  disabled,
}) => {
  const textFieldErrors =
    formMethods.formState.errors.globalForm?.customTexts?.texts;
  return (
    <ErrorBoundary>
      <Flex gap="18px" flexDirection="column" width="100%">
        <Stack gap="6px">
          <Text variant="xs">Skriv egendefinert melding</Text>
          <Text variant="xs">
            Hjelpetekster til ulike situasjoner finnes{" "}
            <TextLink
              tabIndex={-1}
              href="https://vygruppen.atlassian.net/wiki/spaces/KUNDEINFO/pages/7180877920/Ekstra+kundeinformasjon+ved+store+oppst+tte+avvik+og+hendelser"
            >
              her
            </TextLink>
          </Text>
        </Stack>
        <TextAreaWithCharacterCount
          label="Norsk overskrift *"
          formMethods={formMethods}
          maxLength={60}
          formField="NOB.title"
          invalid={!!textFieldErrors?.NOB?.title}
          errorMessage={textFieldErrors?.NOB?.title?.message}
          disabled={disabled}
        />
        <TextAreaWithCharacterCount
          label="Norsk tekst *"
          formMethods={formMethods}
          maxLength={425}
          minHeight="150px"
          formField="NOB.description"
          invalid={!!textFieldErrors?.NOB?.description}
          errorMessage={textFieldErrors?.NOB?.description?.message}
          disabled={disabled}
        />
        <TextAreaWithCharacterCount
          label="English title"
          formMethods={formMethods}
          maxLength={60}
          formField="ENG.title"
          invalid={!!textFieldErrors?.ENG?.title}
          errorMessage={textFieldErrors?.ENG?.title?.message}
          disabled={disabled}
        />
        <TextAreaWithCharacterCount
          label="English text"
          formMethods={formMethods}
          maxLength={425}
          minHeight="150px"
          formField="ENG.description"
          invalid={!!textFieldErrors?.ENG?.description}
          errorMessage={textFieldErrors?.ENG?.description?.message}
          disabled={disabled}
        />

        {/* <Input leftIcon={<ChainLinkIcon />} label="Legg til lenke" /> */}
      </Flex>
    </ErrorBoundary>
  );
};
